import { DaymapQuery as n } from "../daymapQuery.js";
import { interviews as i } from "../../types/interviews/index.js";
import "../../types/contacts/index.js";
import "../../types/points/index.js";
import "../../types/projects/index.js";
import "../../types/groups/index.js";
var o;
((a) => {
  class w extends n {
    constructor(e, s) {
      super(
        ["InterviewGroups", e, s],
        { from: e, to: s },
        `/lms/api/interviews/groups?from=${e ? e.toJSON() : ""}&to=${s ? s.toJSON() : ""}`,
        null,
        {
          select: (t) => {
            let r = t;
            return r = r.map((u) => ({
              ...u,
              From: new Date(u.From),
              To: new Date(u.To),
              Status: i.GroupStatusEnum[i.GroupStatusEnum[u.Status]]
            })), r;
          },
          stale: 1e3 * 60 * 5
        }
      );
    }
  }
  a.InterviewGroups = w;
  class c extends n {
    constructor(e) {
      super(
        ["InterviewGroup", e],
        { groupId: e },
        `/lms/api/interviews/${e}`,
        null,
        {
          select: (s) => {
            let t = s;
            return t = {
              ...t,
              From: new Date(t.From),
              To: new Date(t.To),
              Status: i.GroupStatusEnum[i.GroupStatusEnum[t.Status]]
            }, t;
          },
          stale: 1e3 * 60 * 5
        }
      );
    }
  }
  a.InterviewGroup = c;
  class I extends n {
    constructor(e) {
      super(
        ["InterviewSlots", e],
        { groupId: e },
        `/lms/api/interviews/${e}/slots`,
        null,
        {
          select: (s) => {
            let t = s;
            return t = t.map((r) => ({
              ...r,
              From: new Date(r.From),
              To: new Date(r.To)
            })), t;
          },
          stale: 1e3 * 60 * 5
        }
      );
    }
  }
  a.InterviewSlots = I;
  class v extends n {
    constructor(e) {
      super(
        ["InterviewTeachers", e],
        { groupId: e },
        `/lms/api/interviews/${e}/teachers`,
        null,
        {
          stale: 1e3 * 60 * 5
        }
      );
    }
  }
  a.InterviewTeachers = v;
  class m extends n {
    constructor(e) {
      super(
        ["InterviewSlotDetails", e.groupId, e.slotId, e.staffId, e.classId],
        e,
        `/lms/api/interviews/${e.groupId}/slot/${e.slotId}?studentId=${e.studentId}&staffId=${e.staffId}&classId=${e.classId}`,
        null,
        {
          stale: 1e3 * 60 * 5
        }
      );
    }
  }
  a.InterviewSlotDetails = m;
})(o || (o = {}));
export {
  o as interviews
};
//# sourceMappingURL=index.js.map
